export const statusProcessoModel = {
  statusProcesso: function () {
    return {
      id: '',
      ds_situacao: '',
      numordem: '',
    }
  },
}


// WEBPACK FOOTER //
// ./src/models/statusProcesso.js